import SchoolPersonalDetails from './SchoolPersonalDetails.page';

export default SchoolPersonalDetails;